import { ROUTE_CONSTANTS } from "../../routes/RouteConstants";
import { IMAGES } from "../ImageConstants";

export const ANNOUNCEMENTS_DATA = [
   {
      "id" : "experience-the-next-level-of-document-intelligence-with-our-latest-offering-leaf-idp",
      "title" : "Experience the next level of document intelligence with our latest offering, Leaf IDP",
      "sub_text" : "Elevate document analysis with our intelligent document processing application, extracting key information swiftly and accurately.",
      "date" : "01-02-2024",
      "banner_image" : IMAGES.ANNOUNCEMENTS.BANNER.BYOLLM_ANNOUNCE
   },
   {
      "id" : "g2-ranks-vivasai-as-a-high-performer-in-machine-learning-software",
      "title" : "G2 ranks Vivas.AI as a High Performer in Machine Learning Software",
      "sub_text" : "Vivas.AI is a one-stop marketplace to access a wide range of AI models for various use cases accross industries.",
      "date" : "01-01-2024",
      "banner_image" : IMAGES.ANNOUNCEMENTS.BANNER.G2RANKING_ANNOUNCE
   },{
      "id" : "join-the-buzz-around-vivasai-on-product-hunt-and-explore-our-ai-revolution",
      "title" : "Join the buzz around Vivas.AI on Product Hunt and explore our AI revolution",
      "sub_text" : "Vivas.AI aims to democratize pre-trained AI/ML models from various model providers for citizen developers by simply dragging and dropping them in their low code platform of choice.",
      "date" : "27-04-2023",
      "banner_image" : IMAGES.ANNOUNCEMENTS.BANNER.PRODUCTLAUNCH_ANNOUNCE
   },{
      "id" : "embrace-full-data-autonomy-with-vivasai-new-self-hosting-options",
      "title" : "Embrace full data autonomy with Vivas.AI's new Self-hosting options",
      "sub_text" : "Take control with Vivas.AI's new self-hosting feature, offering you unparalleled data sovereignty.",
      "date" : "12-29-2023",
      "banner_image" : IMAGES.ANNOUNCEMENTS.BANNER.SELFHOSTING_ANNOUNCE
   }
   //  {
   //    "id" : "unleash-the-power-of-vivasai-with-self-hosting-your-models-your-control",
   //    "title" : "Unleash the Power of Vivas.AI with Self-hosting - Your Models, Your Control",
   //    "sub_text" : "We're excited to announce a groundbreaking feature that empowers you to take control of your AI/ML experience like never before – introducing \"Self-hosting\" for Vivas.AI models!",
   //    "date" : "12-29-2023",
   //    "view_page" : ROUTE_CONSTANTS.ANNOUNCEMENTS,
   //    "banner_image" : IMAGES.ANNOUNCEMENTS.BANNER.BYOLLM_ANNOUNCE,
   //    "contents" : [
   //      {
   //        "type": 1,
   //        "content": {
   //           "value": "What's New?",
   //           "meta": []
   //        }
   //      },
   //      {
   //       "type": 2,
   //       "content": {
   //          "value": "Now, you have the flexibility to deploy and run all your favourite Vivas.AI models as containers, giving you the freedom to choose between managed cloud services or on-premise deployments.",
   //          "meta": []
   //       }
   //     },
   //     {
   //       "type": 1,
   //       "content": {
   //          "value": "Why Self-hosting?",
   //          "meta": []
   //       }
   //     },
   //      {
   //            "type": 5,
   //            "content": [
   //               {
   //                  "value": "Unparalleled Control:\n Seamlessly integrate Vivas.AI models into your infrastructure, whether it's on the cloud or on your own premises, putting you in the driver's seat.",
   //                  "meta": [
   //                     {
   //                        "type": "bold",
   //                        "start": 0,
   //                        "text": "Unparalleled Control:"
   //                     }
   //                  ]
   //               },
   //               {
   //                  "value": "Enhanced Privacy and Security:\n Experience the peace of mind that comes with hosting your AI models on your terms, ensuring that sensitive data stays exactly where it belongs - under your control.",
   //                  "meta": [
   //                     {
   //                        "type": "bold",
   //                        "start": 0,
   //                        "text": "Enhanced Privacy and Security:"
   //                     }
   //                  ]
   //               },
   //               {
   //                  "value": "Optimised Performance:\n Enjoy improved latency and response times by deploying models closer to your data sources, ensuring faster insights and more efficient decision-making.",
   //                  "meta": [
   //                     {
   //                        "type": "bold",
   //                        "start": 0,
   //                        "text": "Optimised Performance:"
   //                     }
   //                  ]
   //               },
   //               {
   //                  "value": "Scalability at Your Fingertips:\n Easily scale your AI/ML operations to meet the demands of your growing business, with the ability to manage resources according to your specific requirements.",
   //                  "meta": [
   //                     {
   //                        "type": "bold",
   //                        "start": 0,
   //                        "text": "Scalability at Your Fingertips:"
   //                     }
   //                  ]
   //               }
   //            ]
   //         },
   //      {
   //        "type": 1,
   //        "content": {
   //           "value": "For Developers:",
   //           "meta": []
   //        }
   //      },
   //      {
   //       "type": 2,
   //       "content": {
   //          "value": "Explore our comprehensive documentation and API guides to seamlessly integrate Vivas.AI models into your existing workflows. Harness the power of AI with simplicity and efficiency.",
   //          "meta": []
   //       }
   //     },
   //     {
   //       "type": 1,
   //       "content": {
   //          "value": "For Businesses:",
   //          "meta": []
   //       }
   //     },
   //     {
   //      "type": 2,
   //      "content": {
   //         "value": "Whether you're a business leader seeking agility or a curious mind delving into the realms of AI/ML, Self Hosting is your gateway to a world of possibilities.\n\nUnlock new possibilities for innovation and efficiency by incorporating Vivas.AI models into your AI strategy.\n\nEmpower your enterprise with Vivas.AI On-Self-hosting. Gain unparalleled advantages:",
   //         "meta": []
   //      }
   //      },
   //      {
   //            "type": 4,
   //            "content": [
   //               {
   //                  "value": "Complete Control:\nSelf-hosting provides businesses with full control over their infrastructure, data, and applications. This level of control allows for customization to meet specific business needs and requirements.",
   //                  "meta": [
   //                   {
   //                      "type": "bold",
   //                      "start": 0,
   //                      "text": "Complete Control:"
   //                   }
   //                  ]
   //               },
   //               {
   //                "value": "Enhanced Security:\nWith self-hosting, sensitive data is kept within the organisation's secure environment. This enables businesses to implement and manage security measures that align with their specific standards and policies.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Enhanced Security:"
   //                 }
   //                ]
   //             },
   //             {
   //                "value": "Compliance and Regulation Adherence:\nOn-premises hosting facilitates easier adherence to industry-specific compliance regulations and standards. This is crucial for businesses operating in regulated industries, ensuring they meet legal and regulatory requirements.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Compliance and Regulation Adherence:"
   //                 }
   //                ]
   //             },
   //             {
   //                "value": "Cost Efficiency:\nSelf-hosting eliminates recurring monthly fees associated with third-party cloud services. Businesses can optimise resource allocation based on their usage patterns, potentially resulting in cost savings over time.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Cost Efficiency:"
   //                 }
   //                ]
   //             },
   //             {
   //                "value": "Performance and Speed:\nHosting applications on-premises often leads to faster access and lower latency. This can contribute to improved performance and responsiveness, particularly for applications critical to business operations.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Performance and Speed:"
   //                 }
   //                ]
   //             },
   //             {
   //                "value": "Customizable Scalability:\nSelf-hosting allows businesses to scale their infrastructure based on their growth and requirements. This scalability is customizable, enabling organisations to integrate new technologies and upgrades at their own pace.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Customizable Scalability:"
   //                 }
   //                ]
   //             },
   //             {
   //                "value": "Independence from External Networks:\nBy hosting applications on-premises, businesses reduce reliance on external network connections. This independence enhances reliability and ensures consistent performance even during network disruptions.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Independence from External Networks:"
   //                 }
   //                ]
   //             },
   //             {
   //                "value": "Optimised Resource Allocation:\nBusinesses can allocate resources according to their specific needs, optimising the use of hardware and software to match their unique workflow and demands.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Optimised Resource Allocation:"
   //                 }
   //                ]
   //             },
   //             {
   //                "value": "Data Sovereignty:\nSelf-hosting provides businesses with control over the physical location of their data, ensuring compliance with data sovereignty regulations and policies.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Data Sovereignty:"
   //                 }
   //                ]
   //             },
   //             {
   //                "value": "Mitigation of Vendor Lock-In:\nChoosing self-hosting minimises dependence on external service providers, mitigating the risk of vendor lock-in. This independence allows businesses to switch technologies or providers more easily if necessary.",
   //                "meta": [
   //                 {
   //                    "type": "bold",
   //                    "start": 0,
   //                    "text": "Mitigation of Vendor Lock-In:"
   //                 }
   //                ]
   //             }
                 
   //            ]
   //         },
   //      {
   //        "type": 2,
   //        "content": {
   //           "value": "Choose Vivas.AI  for a hosting solution that aligns with your enterprise's unique needs and accelerates your business growth. Get started today!",
   //           "meta": []
   //        }
   //      },
   //      {
   //        "type": 1,
   //        "content": {
   //           "value": "How to Get Started:",
   //           "meta": []
   //        }
   //      },
   //      {
   //       "type": 2,
   //       "content": {
   //          "value": "If you are an existing user, You can find the detailed model specific hosting tips in the individual model detailing page.\nAt Vivas.AI, we believe in putting the power of AI in your hands. With Self-hosting, you're not just using AI - you're shaping it to fit your unique vision.\nReady to embark on this exciting journey? Start Self-hosting today and elevate your AI experience!",
   //          "meta": []
   //       }
   //     },
   //      {
   //        "type": 2,
   //        "content": {
   //           "value": "Best regards,\nTeam Vivas.AI",
   //           "meta": []
   //        }
   //      }
   //    ]
   //  }
  ]